import { render, staticRenderFns } from "./NextRaceTeaser.vue?vue&type=template&id=278d83e3"
import script from "./NextRaceTeaser.vue?vue&type=script&lang=js"
export * from "./NextRaceTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports